import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CongressSelectorService } from '../services/congress-selector.service';

/**
 * Réserve /pending aux comptes non approuvés, et aux comptes qui ont accès à l'app quand aucune
 * édition n'existe (la page le dit alors). Un compte qui a accès repart au cockpit dès qu'une
 * édition existe ; sans édition, un admin part sur /admin.
 */
export const pendingGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const congress = inject(CongressSelectorService);
  const router = inject(Router);

  if (!auth.backendReachable()) {
    return router.createUrlTree(['/unavailable']);
  }
  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }
  if (!auth.canAccessApp()) {
    return true;
  }
  await congress.load();
  if (!auth.backendReachable()) {
    return router.createUrlTree(['/unavailable']);
  }
  if (congress.defaultId()) {
    return router.createUrlTree(['/']);
  }
  return auth.isAdmin() ? router.createUrlTree(['/admin']) : true;
};
